module.exports = __webpack_public_path__ + "img/template-mobile-4.fa6645b5.svg";